//import Cookies from 'js-cookie';
import * as ActionTypes from '../constants/actionTypes';
//const YTECH_COOKIE_NAME = 'ytech-auth-user';

const initialState = {
	error: null,
	loading: null,
};

export default function product(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.PRODUCT_REQUESTED:
			return {
				...state,
				loading: true,
			};
		case ActionTypes.PRODUCT_UPDATED:
		case ActionTypes.PRODUCT_SUCCEEDED: {
			if (action.product)
				return {
					...state,
					[action.product.product_type]: action.product,
					error: null,
					loading: null,
				};
			break;
		}
		case ActionTypes.PRODUCT_FAILED: {
			return {
				...state,
				error: action.error,
				loading: null,
			};
		}
		case ActionTypes.LOGOUT_SUCCEEDED: {
			return {
				error: null,
				loading: null,
			};
		}
		default:
			break;
	}
	return state;
}
